export enum MoiCreatorPermissions {
    None = 0,
    BimCreator = 1 << 0,
    RiskMoiCreator = 1 << 1,
    ControlMoiCreator = 1 << 2,
    EventMoiCreator = 1 << 3,
    DmMoiCreator = 1 << 4,
    TpMoiCreator = 1 << 5,
}
